export default __webpack_public_path__ + "static/media/Shadow's Edge.a107a671.jpg";